import { FC } from "react";
import Translate from "../Translate/Translate";

/**
 * Component that takes a list of strings and renders them as human-readable text.
 * For example, ["A", "B", "C"] would be rendered as "A, B and C".
 */
const ListToText: FC<{ list: string[]; bold?: boolean }> = ({
  list,
  bold = false
}) => {
  if (list.length === 0) {
    return null;
  }

  if (list.length === 1) {
    return <span className={bold ? "strong" : ""}>{list[0]}</span>;
  }

  return (
    <Translate
      msg="listItems"
      variables={{
        context: bold ? "bold" : undefined,
        firstFewWithoutLast: list.slice(0, -1).join(", "),
        lastItem: list[list.length - 1]
      }}
    />
  );
};

export default ListToText;
